import React from 'react';

export default function StudentGoalsComingSoon() {
  return (
    <section
      aria-label="Student Goals"
      style={{
        width: '100%',
        maxWidth: 720,
        boxSizing: 'border-box',
        padding: 24,
        borderRadius: 18,
        background: 'var(--ae-surface)',
        border: '1px solid var(--ae-border)',
        boxShadow: 'var(--ae-shadow-card)',
      }}
    >
      <h1 style={{ margin: '0 0 12px', fontSize: 28, fontWeight: 800, color: 'var(--ae-primary-strong)' }}>
        Student Goals
      </h1>
      <p style={{ margin: 0, fontSize: 16, fontWeight: 600, color: 'var(--ae-text-muted)' }}>
        Coming soon
      </p>
    </section>
  );
}
